export const defaultMenuType = 'menu-default' // 'menu-default', 'menu-sub-hidden', 'menu-hidden';
export const adminRoot = '/admin'
export const apiUrl = process.env.VUE_APP_API_URL

export const subHiddenBreakpoint = 1440
export const menuHiddenBreakpoint = 768

export const defaultLocale = 'ru'
export const localeOptions = [
  { id: 'en', name: 'English' },
  { id: 'ru', name: 'Русский' }
]

export const themeRadiusStorageKey = 'theme_radius'
export const themeSelectedColorStorageKey = 'theme_selected_color'
export const defaultColor = 'light.greenlime'
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'orangecarrot',
  'redruby',
  'greysteel'
]
